import {NgModule} from '@angular/core';
import {IntroPageComponent} from './introPage/introPage.component';
import {LoginPageComponent} from './loginPage/loginPage.component';
import {PrivacyPageComponent} from './privacyPage/privacyPage.component';
import {RouterModule} from '@angular/router';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {SIDRCommonModule} from '../common/sidrCommon.module';
import {DemoComponent} from './demoPage/demo.component';
import {FormsModule} from '@angular/forms';
import {ForgotPasswordComponent} from './forgotpassword/forgotpassword.component';
import {CommonModule} from '@angular/common';
import {ChangePasswordComponent} from './changePassword/changePassword.component';

@NgModule({
  declarations: [
    IntroPageComponent,
    LoginPageComponent,
    ForgotPasswordComponent,
    PrivacyPageComponent,
    ChangePasswordComponent,
    DemoComponent
  ],
  imports: [
    RouterModule,
    NgbModule,
    FormsModule,
    SIDRCommonModule,
    CommonModule,
  ],
  exports: [
    IntroPageComponent,
    LoginPageComponent,
    ForgotPasswordComponent,
    ChangePasswordComponent,
    PrivacyPageComponent,
    DemoComponent
  ],
  providers: []
})
export class UnauthenticatedModule {
}
